<template>
  <div class="game_box">
    <div class="game_title">{{ $t("gameinfo.material.game_material") }}</div>
    <div class="xian"></div>
    <div class="game">
      <div class="select_i8 material">
        <!-- :class="selectData.length <= 0?'TGAdd':''" -->
        <div class="TGA_INPUT_BOX material_box">
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("gameinfo.material.gamelogo") }}
          </div>

          <div class="updata CU">
            <el-upload
              :action="upload_url"
              :drag="false"
              class="avatar-uploader"
              :http-request="up_load"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="icon && !upload_loading"
                :src="icon"
                style="width: 90px; height: 90px"
                class="avatar"
              />
              <img
                v-if="!icon && !upload_loading"
                class="upload_img"
                style="width: 90px; height: 90px"
                :src="$t('gameinfo.material.uploadimg')"
                alt=""
              />
              <img
                v-if="upload_loading"
                src="@/img/up_loading.gif"
                class="upload_img"
                alt=""
              />
            </el-upload>
          </div>
          <div class="init_text">
            <ul>
              <li>{{ $t("gameinfo.material.format") }}</li>
              <li>{{ $t("gameinfo.material.size") }}</li>
              <li>{{ $t("gameinfo.material.size2") }}</li>
            </ul>
          </div>
        </div>

        <div class="BASIC MG_B10">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              <span class="must">*</span>
              {{ $t("gameinfo.material.width") }}
            </div>
            <input
              type="number"
              v-model="width"
              style="height: 40px"
              class="TGA_INPUT TGA_PD"
              :placeholder="$t('gameinfo.material.width')"
            />
          </div>
        </div>
        <div class="BASIC MG_B10">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              <span class="must">*</span>
              {{ $t("gameinfo.material.height") }}
            </div>
            <input
              type="number"
              v-model="height"
              style="height: 40px"
              class="TGA_INPUT TGA_PD"
              :placeholder="$t('gameinfo.material.height')"
            />
          </div>
        </div>

        <!-- 单选框 -->
        <div class="BASIC">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              <span class="must">*</span>
              {{ $t("gameinfo.material.type") }}
            </div>
            <div class="radio_btn">
              <div class="CU radio_chunk" @click="SelectGameType('sdk')">
                <img
                  class="radio_img"
                  v-if="gameType == 'sdk'"
                  src="@/img/radio.png"
                  alt=""
                />
                <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
                <span class="radio_text">{{
                  $t("gameinfo.material.sdk")
                }}</span>
              </div>
              <div
                class="CU radio_chunk"
                style="margin-left: 45px"
                @click="SelectGameType('other')"
              >
                <img
                  class="radio_img"
                  v-if="gameType == 'other'"
                  src="@/img/radio.png"
                  alt=""
                />
                <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
                <span class="radio_text">{{
                  $t("gameinfo.material.other")
                }}</span>
              </div>
              <el-tooltip class="item" effect="dark" placement="right-start">
                <div slot="content" class="tip">
                  {{ $t("gameinfo.material.tip") }}<br />
                  {{ $t("gameinfo.material.tipFirst") }}<br />
                </div>
                <img class="order_title_img" src="@/img/init.png" alt="" />
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="BASIC">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              <span class="must">*</span>
              {{ $t("gameinfo.material.cooperation") }}
            </div>
            <div class="radio_btn">
              <div class="CU radio_chunk" @click="SelectRadio(0)">
                <img
                  class="radio_img"
                  v-if="radio == 0"
                  src="@/img/radio.png"
                  alt=""
                />
                <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
                <span class="radio_text">{{
                  $t("gameinfo.material.myservers")
                }}</span>
              </div>
              <div
                class="CU radio_chunk"
                style="margin-left: 45px"
                @click="SelectRadio(1)"
              >
                <img
                  class="radio_img"
                  v-if="radio == 1"
                  src="@/img/radio.png"
                  alt=""
                />
                <img class="radio_img" v-else src="@/img/no_radio.png" alt="" />
                <span class="radio_text">{{
                  $t("gameinfo.material.platformservers")
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="BASIC MG_B10" v-if="radio == 0">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              <span class="must">*</span>
              {{ $t("gameinfo.material.url") }}
            </div>
            <!-- v-model="appname" @blur.prevent="changeCount()"  -->
            <input
              type="text"
              v-model="playUrl"
              style="height: 40px"
              class="TGA_INPUT TGA_PD"
              :placeholder="$t('gameinfo.material.gameurl')"
            />
          </div>
        </div>
        <div class="BASIC MG_B10" v-if="radio == 2">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              <span class="must">*</span>
              {{ $t("gameinfo.material.url") }}
            </div>
            <!-- v-model="appname" @blur.prevent="changeCount()"  -->
            <input
              type="text"
              v-model="playUrl"
              style="height: 40px"
              class="TGA_INPUT TGA_PD"
              :placeholder="$t('gameinfo.material.gameurl')"
            />
          </div>
        </div>

        <!-- 这个是上传 文件的-->
        <div
          class="TGA_INPUT_BOX material_box file game_btn_box"
          v-if="radio == 1"
        >
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("gameinfo.material.gamemainfile") }}
          </div>

          <div class="updata CU">
            <el-upload
              :action="upload_file"
              :drag="false"
              class="avatar-uploader"
              :http-request="up_load_file"
              :show-file-list="false"
              :before-upload="Uploadfile"
            >
              <div class="uploadSuccess" style="" v-if="playUrl">
                <img
                  src="@/img/compress.png"
                  style="width: 34px; height: 32px"
                  class="avatar"
                />
              </div>
              <img
                v-else
                class="upload_img"
                style="width: 90px; height: 90px"
                src="@/img/file.png"
                alt=""
              />
            </el-upload>
          </div>

          <div
            class="game_btn_preview CU"
            v-if="playUrl && !fileUrlState"
            @click="preview"
          >
            {{ $t("gameinfo.material.gamepreview") }}
          </div>

          <div class="game_btn_preview CU" v-if="fileUrlState">
            {{ $t("gameinfo.material.onthecross") }}
          </div>
        </div>

        <div class="game_btn_preview_progress" v-if="progressVisible">
          <el-progress
            :text-inside="true"
            :stroke-width="26"
            :percentage="progress"
          ></el-progress>
        </div>

        <div class="file_text_box" v-if="radio == 1">
          <div class="file_text">{{ $t("gameinfo.material.text") }}</div>
          <div class="file_text">{{ $t("gameinfo.material.text1") }}</div>
          <div class="file_text">{{ $t("gameinfo.material.text2") }}</div>
        </div>

        <div class="hint" v-if="radio == 1">
          <div>{{ $t("gameinfo.material.attention") }}</div>
          <div>{{ $t("gameinfo.material.text3") }}</div>
          <div>
            {{ $t("gameinfo.material.text4") }}
            <span class="CU" @click="copy(configs)"
              >{{ configs }}({{ $t("gameinfo.material.copy") }})</span
            >
          </div>
        </div>
        <!-- :class="BTN?'':'btn_active'"   @click="establish"-->
        <div class="btn CU" :class="BTN ? '' : 'btn_active'" @click="send">
          {{ $t("gameinfo.material.send") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/utils/config.js";
export default {
  data() {
    return {
      configs: configs.serviceEmail(),
      BTN: false,
      icon: "",
      upload_url: "",
      playUrl: "",
      openfileUrl: "",
      upload_file: "",
      gameId: this.$route.query.gameId,
      appId: this.$route.query.appId,
      fileUrlState: false,
      progressVisible: false,
      radio: 0,
      gameType: "sdk",
      upload_loading: false,
      progress: 0,
      width: "",
      height: "",
    };
  },
  computed: {
    ...mapState("game", ["baseInfo", "GameAppInfo"]),
  },
  created() {
    if (this.GameAppInfo == "") {
      this.load();
    } else {
      this.vuexLoad();
    }
  },
  mounted() {},
  methods: {
    ...mapActions("user", [
      "tipMessage",
      "FileUpload",
      "FileContraZip",
      "FileUnZip",
      "FileState",
    ]),
    ...mapActions("game", ["getGameDeveloperInfo", "updateGameDeveloper"]),
    setProgress(complete) {
      if (complete) {
        this.progress = 100;
      } else {
        if (this.progress < 99) {
          this.progress = this.progress + 1;
        }
      }
    },

    SelectRadio(radio) {
      this.radio = radio;
    },
    SelectGameType(text) {
      this.gameType = text;
    },

    async load() {
      var res = await this.getGameDeveloperInfo({
        $axios: this.$axios,
        gameId: this.gameId,
      });
      if (res.code == 200) {
        this.icon = res.data.gameDeveloperVo.icon;
        this.playUrl = res.data.gameDeveloperVo.playUrl;
        this.radio = res.data.gameDeveloperVo.gamePlatform || 0;
        this.gameType = res.data.gameDeveloperVo.gameType;
        this.width = res.data.gameDeveloperVo.width;
        this.height = res.data.gameDeveloperVo.height;
      }
    },

    vuexLoad() {
      var data = this.GameAppInfo.gameDeveloperVo;
      this.icon = data.icon;
      this.playUrl = data.playUrl;
      this.radio = data.gamePlatform || 0;
      this.gameType = data.gameType;
      this.width = data.width;
      this.height = data.height;
    },

    // 点击提交素材
    async send() {
      if (!this.icon || !this.playUrl) {
        this.$message.error(this.$t("gameinfo.material.logoinfo"));
        return;
      }
      if (this.IsImgstate || this.fileUrlState) {
        this.$message.warning(this.$t("gameinfo.material.onthecrossinfo"));
        return;
      }

      var res = await this.updateGameDeveloper({
        $axios: this.$axios,
        id: this.gameId,
        icon: this.icon,
        playUrl: this.playUrl,
        gamePlatform: this.radio,
        gameType: this.gameType,
        width: this.width,
        height: this.height,
      });
      if (res.code == 200) {
        this.load();
        this.$message.success(this.$t("gameinfo.material.save_success"));
      }
    },

    // 点击预览
    preview() {
      const url =
        configs.previewUrl(
          localStorage.getItem("mp_accessToken"),
          this.appId,
          this.gameId
        ) + this.playUrl;

      window.open(url);
    },

    // 这个是文件上传
    Uploadfile(file) {
      console.log("filefilefile", file);
      var zip =
        file.type === "application/x-zip-compressed" ||
        file.type === "application/zip";

      if (!zip) {
        this.$message.error(this.$t("gameinfo.material.onthecrosszip"));
        return false;
      }

      this.fileUrlState = true;
      this.progressVisible = true;
      this.progress = 0;

      this.UnZip(file);

      return true;
    },

    up_load_file(file) {},

    beforeAvatarUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type == "image/png" ||
        file.type === "image/gif";
      const isLt2M = file.size / 1024 < 50;
      if (!isJpgOrPng) {
        this.$message.error(this.$t("gameinfo.material.onthecrossimg"));
        return false;
      }
      if (!isLt2M) {
        this.$message.error(this.$t("gameinfo.material.onthecrosslogo"));
        return false;
      }
      this.upload_loading = true;
      this.Upload(file, "img");
      this.IsImgstate = true;
      return true;
    },

    async Upload(file, state) {
      var res = await this.FileUpload({
        $axios: this.$axios,
        file: file,
      });
      if (res.stateCode == 1) {
        this.$message.success(this.$t("gameinfo.material.upsuccess"));
        this.upload_loading = false;
        this.IsImgstate = false;
        this.icon = res.resultInfo.data;
      } else {
        this.$message.error(this.$t("gameinfo.material.uperror"));
      }
    },

    async UnZip(file) {
      var res = await this.FileUnZip({
        $axios: this.$axios,
        file: file,
      });
      if (res.stateCode == 1) {
        this.ContraZip(res.resultInfo.fileId);
      } else {
        this.fileUrlState = false;
        this.progressVisible = false;
        this.$message.error(this.$t("gameinfo.material.uperror"));
      }
    },

    // 文件解压接口
    async ContraZip(fileId) {
      var self = this;
      var res = await this.FileState({
        $axios: this.$axios,
        fileId: fileId,
      });
      if (res.stateCode == 1) {
        if (!res.resultInfo.state) {
          setTimeout(function () {
            self.ContraZip(fileId);
            self.setProgress();
          }, 1000);
        } else {
          self.setProgress(true);
          setTimeout(function () {
            self.progressVisible = false;
          }, 2000);
          this.fileUrlState = false;

          this.playUrl = res.resultInfo.data;
          this.openfileUrl =
            configs.previewUrl(
              localStorage.getItem("mp_accessToken"),
              this.appId,
              this.gameId
            ) + res.resultInfo.data;
        }
        console.log("resresresres", res);
      }
    },

    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.info(this.$t("gameinfo.material.copysuccess"));
      // this.$message({
      //   message: '复制成功',
      //   type: 'success'
      // });
      oInput.remove();
    },

    handleValueChange() {
      if (this.height && this.width && this.icon && this.playUrl) {
        this.BTN = true;
      } else {
        this.BTN = false;
      }
    },
  },

  watch: {
    height: {
      handler: function (newValue, oldValue) {
        this.handleValueChange();
      },
      deep: true,
    },
    width: {
      handler: function (newValue, oldValue) {
        this.handleValueChange();
      },
      deep: true,
    },
    icon: {
      handler: function (newValue, oldValue) {
        this.handleValueChange();
      },
      deep: true,
    },
    playUrl: {
      handler: function (newValue, oldValue) {
        this.handleValueChange();
      },
      deep: true,
    },
  },
};
</script>

<style scoped="scoped">
.game_box {
  width: 100%;
  height: 100%;
}
.game_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}
.xian {
  width: 100%;
  height: 1px;
  margin-top: 14px;
  background-color: #f3f3f3;
}
.game {
  margin-top: 31px;
  /* padding-left: 50px; */
}
.material {
  padding-left: 175px;
}
.material .TGA_TEXT {
  line-height: 90px;
}
.material_box {
  display: flex;
}
.file {
  margin-top: 25px;
}
.BASIC {
  margin-top: 40px;
}
.radio_btn {
  height: 40px;
  /* width: 367px; */
  display: flex;
  align-items: center;
}
.init_text {
  margin-left: 138px;
  color: #aaaaaa;
  font-size: 12px;
}
.init_text ul {
  padding: 0;
  margin: 0;
  padding-top: 15px;
}
.init_text ul li {
  line-height: 12px;
  margin-bottom: 10px;
}
.init_text ul li:nth-last-of-type(1) {
  margin-bottom: 0;
}
.file_text_box {
  margin-top: 19px;
  width: 613px;
  color: #aaaaaa;
}
.file_text_box .file_text {
  font-size: 12px;
  line-height: 20px;
  word-break: break-all;
}
.hint {
  margin-top: 29px;
  font-size: 12px;
  color: #f65651;
}
.hint span {
  color: #4990fa;
}

.btn {
  margin: 40px 0 0 0px;
  width: 367px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
}

.game_btn_preview {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #aaaaaa;
  color: #666666;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  margin-left: 118px;
}
.game_btn_preview_progress {
  width: 500px;
  margin-top: 19px;
}
.game_btn_box {
  display: flex;
  align-items: center;
}

.uploadSuccess {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  /* border: 1px solid #dddddd; */
}
.btn_active {
  background-color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/games/gameinfo/material.vue